import React, { useContext, useState, useRef, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import {
  FiMenu,
  FiHome,
  FiBookOpen,
  FiInfo,
  FiMail,
  FiUser,
  FiSettings,
  FiLogOut,
} from "react-icons/fi";
import styles from "./Header.module.css";
import buttonStyles from "../styles/Buttons.module.css";

export default function Header() {
  const { user, logout } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const menuRef = useRef();

  const currentPath = location.pathname;
  const hidePublicLinks = ["/courses", "/admin", "/profile", "/login", "/register", "/", "/verify-email"].some(path =>
    currentPath.startsWith(path)
  );

  const isAuthPage = ["/"].includes(currentPath);

  useEffect(() => {
    const onClick = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    window.addEventListener("click", onClick);
    return () => window.removeEventListener("click", onClick);
  }, []);

  const handleLogout = () => {
    logout();
    navigate("/");
  };

  return (
    <header className={styles.header}>
      <Link to="/" className={styles.left}>
        <img src="/assets/medicina.png" alt="Medicina Total" className={styles.logo} />
        <span className={styles.brand}>Medicina Total</span>
      </Link>

      {!hidePublicLinks && (
        <nav className={styles.nav}>
          <Link to="/">
            <FiHome /> <span>Inicio</span>
          </Link>
          <Link to="/courses">
            <FiBookOpen /> <span>Cursos</span>
          </Link>
          <Link to="/about">
            <FiInfo /> <span>Acerca de</span>
          </Link>
          <Link to="/contact">
            <FiMail /> <span>Contacto</span>
          </Link>
        </nav>
      )}
      {!user && isAuthPage && (
        <div className={styles.authButtons}>
          <button
            onClick={() => navigate("/login")}
            className={buttonStyles.btnSecondary}
          >
            Iniciar Sesión
          </button>
          <button
            onClick={() => navigate("/register")}
            className={buttonStyles.btnPrimary}
          >
            Regístrate
          </button>
        </div>
      )}
      {user && (
        <div className={styles.userMenu} ref={menuRef}>
          <button
            className={styles.menuBtn}
            onClick={() => setOpen((o) => !o)}
            aria-label="Abrir menú"
          >
            <FiMenu size={24} />
          </button>
          {open && (
            <div className={styles.sideDrawer}>
              <ul className={styles.drawerMenu}>
                <li>
                  <Link to="/profile" onClick={() => setOpen(false)}>
                    <FiUser /> <span>Mi Perfil</span>
                  </Link>
                </li>
                <li className={styles.separatorSmall} />
                <li>
                  <Link to="/courses" onClick={() => setOpen(false)}>
                    <FiBookOpen /> <span>Mis Cursos</span>
                  </Link>
                </li>
                {user?.role === "admin" && (
                  <>
                    <li className={styles.separatorSmall} />
                    <li>
                      <Link to="/admin" onClick={() => setOpen(false)}>
                        <FiSettings /> <span>Panel Admin</span>
                      </Link>
                    </li>
                  </>
                )}
                <li className={styles.separatorSmall} />
                <li>
                  <button onClick={handleLogout}>
                    <FiLogOut /> <span>Cerrar Sesión</span>
                  </button>
                </li>
              </ul>
            </div>
          )}
        </div>
      )}
    </header>
  );
}
